<script>
import Vue
  from 'vue'
import Component
  from 'vue-class-component'

@Component({})
export default class Create extends Vue {

}
</script>

<template>

</template>

<style
  scoped
  lang="scss">

</style>
